import { CommonEnums } from '../../common.enums';
import { Comment_Inst } from './comment_inst';

export class CanvasComment {
    comment_Inst: Comment_Inst;
    selected: boolean;
    expanded: boolean;
    change_Ind: string;
    commentsArr: Array<string>;  //read only
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;
    gen_Tab_Change_Ind: string;

    constructor() {
        this.comment_Inst = new Comment_Inst();
        this.change_Ind = CommonEnums.defaults.STRING_VAL_NO;
        this.gen_Tab_Change_Ind = CommonEnums.defaults.STRING_VAL_NO;
        this.commentsArr = new Array<string>();
        this.selected = false;
        this.expanded = false;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
    }

    static parse(canvasCommentTmp: any): CanvasComment {
        let canvascomment = new CanvasComment();
        canvascomment.copyFrom(canvasCommentTmp);
        return canvascomment;
    }

    copy(): CanvasComment {
        let canvasCommentTmp = new CanvasComment;
        canvasCommentTmp.comment_Inst = this.comment_Inst.copy();
        canvasCommentTmp.selected = this.selected;
        canvasCommentTmp.expanded = this.expanded;
        canvasCommentTmp.error_Cd = this.error_Cd;
        canvasCommentTmp.error_Msg = this.error_Msg;
        canvasCommentTmp.change_Ind = this.change_Ind;
        canvasCommentTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        canvasCommentTmp.ref_Id = this.ref_Id;
        canvasCommentTmp.ref_Cd = this.ref_Cd;
        canvasCommentTmp.fldr_Id = this.fldr_Id;
        return canvasCommentTmp;
    }

    copyFrom(canvasCommentTmp: CanvasComment): void {
        this.comment_Inst.copyFrom(canvasCommentTmp.comment_Inst);
        this.selected = canvasCommentTmp.selected;
        this.expanded = canvasCommentTmp.expanded;
        this.error_Cd = canvasCommentTmp.error_Cd;
        this.error_Msg = canvasCommentTmp.error_Msg;
        this.change_Ind = canvasCommentTmp.change_Ind;
        this.ref_Id = canvasCommentTmp.ref_Id;
        this.ref_Cd = canvasCommentTmp.ref_Cd;
        this.fldr_Id = canvasCommentTmp.fldr_Id;
        this.gen_Tab_Change_Ind = canvasCommentTmp.gen_Tab_Change_Ind;
    }

    compare(canvasCommentTmp: CanvasComment): string {
        let diffString: string = this.comment_Inst.compare(canvasCommentTmp.comment_Inst);
        if (diffString != '') return diffString;

        return '';
    }

    toString(): string {
        let str = "CanvasComment[ comment_Inst" + this.comment_Inst.toString() + "error_Cd" + this.error_Cd + "error_Msg" + this.error_Msg + "]";

        return str
    }

}
